import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAllPosts, deletePost } from '../../services/blogService';
import '../../App.css';

const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPosts();
  }, []);

  const loadPosts = async () => {
    try {
      const data = await getAllPosts();
      setPosts(data);
    } catch (error) {
      console.error('Error loading posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este post?')) {
      try {
        await deletePost(id);
        setPosts(posts.filter(post => post.id !== id));
      } catch (error) {
        console.error('Error deleting post:', error);
        alert('Error al eliminar el post');
      }
    }
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#0f172a', padding: '2rem', color: '#f1f5f9' }}>
        <p>Cargando...</p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', padding: '2rem' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem'
        }}>
          <h1 style={{ color: '#f1f5f9' }}>📝 Gestión de Blog</h1>
          <div style={{ display: 'flex', gap: '1rem' }}>
            <Link to="/admin/dashboard">
              <button style={{
                padding: '0.75rem 1.5rem',
                borderRadius: '0.5rem',
                border: '1px solid rgba(148, 163, 184, 0.3)',
                background: 'rgba(30, 41, 59, 0.8)',
                color: '#cbd5e1',
                cursor: 'pointer'
              }}>
                ← Volver
              </button>
            </Link>
            <Link to="/admin/blog/create">
              <button style={{
                padding: '0.75rem 1.5rem',
                borderRadius: '0.5rem',
                border: 'none',
                background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                color: 'white',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}>
                + Nuevo Post
              </button>
            </Link>
          </div>
        </div>

        {posts.length === 0 ? (
          <div style={{
            padding: '3rem',
            textAlign: 'center',
            background: 'rgba(30, 41, 59, 0.8)',
            borderRadius: '1rem',
            border: '1px solid rgba(148, 163, 184, 0.2)'
          }}>
            <p style={{ color: '#94a3b8', fontSize: '1.2rem' }}>
              No hay posts aún. ¡Crea el primero!
            </p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {posts.map(post => (
              <div key={post.id} style={{
                padding: '1.5rem',
                background: 'rgba(30, 41, 59, 0.8)',
                borderRadius: '1rem',
                border: '1px solid rgba(148, 163, 184, 0.2)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
                    <h3 style={{ color: '#f1f5f9', margin: 0 }}>{post.title}</h3>
                    <span style={{
                      padding: '0.25rem 0.75rem',
                      borderRadius: '0.25rem',
                      fontSize: '0.75rem',
                      background: post.published ? 'rgba(34, 197, 94, 0.2)' : 'rgba(251, 191, 36, 0.2)',
                      color: post.published ? '#86efac' : '#fde047'
                    }}>
                      {post.published ? 'Publicado' : 'Borrador'}
                    </span>
                  </div>
                  <p style={{ color: '#94a3b8', margin: '0.5rem 0' }}>
                    {post.excerpt || 'Sin extracto'}
                  </p>
                  <p style={{ color: '#64748b', fontSize: '0.875rem', margin: 0 }}>
                    {post.category && `📁 ${post.category}`}
                  </p>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <Link to={`/admin/blog/edit/${post.id}`}>
                    <button style={{
                      padding: '0.5rem 1rem',
                      borderRadius: '0.5rem',
                      border: 'none',
                      background: 'rgba(59, 130, 246, 0.2)',
                      color: '#93c5fd',
                      cursor: 'pointer'
                    }}>
                      ✏️ Editar
                    </button>
                  </Link>
                  <button
                    onClick={() => handleDelete(post.id)}
                    style={{
                      padding: '0.5rem 1rem',
                      borderRadius: '0.5rem',
                      border: 'none',
                      background: 'rgba(239, 68, 68, 0.2)',
                      color: '#fca5a5',
                      cursor: 'pointer'
                    }}
                  >
                    🗑️ Eliminar
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogList;
